// ../../Custom/IntegerField.jsx
import React from 'react';
import { TextField } from '@mui/material';

const IntegerField = ({
  name,
  label,
  value,
  onChange,
  required,
  placeholder,
  fullWidth = true,
  ...props
}) => {
  const handleIntChange = (e) => {
    const v = e.target.value.trim();
    if (v === '') {
      onChange?.({ target: { name, value: '' } });
      return;
    }
    if (/^([1-9]\d*)$/.test(v)) {
      onChange?.({ target: { name, value: v } });
    }
  };

  const handleBlur = () => {
    const v = String(value ?? '').trim();
    const normalized = /^([1-9]\d*)$/.test(v) ? v : '';
    if (normalized !== v) onChange?.({ target: { name, value: normalized } });
  };

  const blockNonNumericKeys = (e) => {
    if (['e', 'E', '+', '-', '.', ','].includes(e.key)) e.preventDefault();
  };

  return (
    <TextField
      label={label}
      name={name}
      value={value ?? ''}
      onChange={handleIntChange}
      onBlur={handleBlur}
      onKeyDown={blockNonNumericKeys}
      placeholder={placeholder}
      fullWidth={fullWidth}
      type="text"
      inputProps={{ inputMode: 'numeric', pattern: '[1-9][0-9]*' }}
      required={required}
      {...props}
    />
  );
};

export default IntegerField;
